import {makeStyles} from "@mui/styles";

export const useStyles = makeStyles((theme: any) => ({
    snackbarError: {
        backgroundColor: '#9c1419'
    }
}));
